import { create } from 'zustand';

// Requests sent to /api/dsh/tsdb since the page loaded, per endpoint.
interface TsdbState {
  served: Record<string, number>;
  record: (endpoint: string) => void;
}

export const useTsdbStore = create<TsdbState>((set) => ({
  served: {},
  record: (endpoint) =>
    set((state) => ({
      served: { ...state.served, [endpoint]: (state.served[endpoint] ?? 0) + 1 },
    })),
}));
